// extracted by mini-css-extract-plugin
module.exports = {"container":"MileInTradeInfo_container__jglYd","title":"MileInTradeInfo_title___sax3","amount":"MileInTradeInfo_amount__nb4wo","description":"MileInTradeInfo_description__n3Zyu"};